<template>
  <tea-main @back="goBack()">
    <template slot="nav">
      <div class="enrollDetailNav">
        <p>中国足协高端教练员继续教育报名</p>
      </div>
    </template>
    <template slot="main">
      <div class="ab_signup_root">
        <div class="main-content-wrap">
          <div class="cont_box" >
            <yioks-loading v-if="loading"></yioks-loading>
            <div class="main"v-show="!loading" >
              <div class="sign_list"  >
                <div class="scroll_wrap">
                  <vue-scroll :ops="vuescrollOpt">
                    <div class="list_content" v-if="dataList.length>0">
                      <div class="item" v-for="item in dataList" :key="item.enroll_id">
                        <div class="item_left">
                          <p class="name " :class="item.enroll_status === 'enrollIncomplete'?'':'gray'">{{item.enroll_name}}&nbsp;&nbsp;&nbsp;({{item.enroll_type | enrollType}})</p>
                          <p class="tiem">
                        <span class="box">
                          报名时间：{{item.enroll_start | time(false)}} 至 {{item.enroll_end | time(false)}}
                        </span>
                            <span class="box">
                          计划开班月份：{{item.class_start | time(false,false)}} 至 {{item.class_end | time(false,false)}}
                        </span>
                            <span class="box">
                          报名人数：{{item.personnelNum}}
                          <span v-if="item.enroll_person_num !== 0">/ {{item.enroll_person_num}}</span>
                        </span>
                          </p>
                        </div>
                        <div class="item_right">
                          <div class="btn sign" :class="item.showSelect?'':'showRes'" v-if="item.enroll_status === 'enrollIncomplete'" @click="signUp(item)">点击报名</div>
                          <div class="btn " :class="{no_begin : item.enroll_status === 'enrollInitiated',over :item.enroll_status !== 'enrollInitiated' ,showRes :!item.showSelect}" v-else>{{statusKV[item.enroll_status].text}}</div>
                          <div class="seletImg" title="审核信息" v-if=" item.showSelect" @click="viewResult(item)"></div>
                        </div>
                        <el-dialog width="350px"
                                   :visible.sync="verifyResult"
                                   custom-class="verify_result_dialog"
                                   :close-on-click-modal="false">
                          <div class="verifyResult">
                            <p>录取状态：{{verifyMsg.status}}</p>
                            <p v-if="verifyMsg.opinion">
                              <span>审核理由：</span>
                              <span>{{verifyMsg.opinion || '--'}}</span>
                            </p>
                          </div>
                        </el-dialog>
                      </div>
                    </div>
                    <div class="empty" v-else>
                      <yioks-empty :h="'100%'"></yioks-empty>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="attention">
                注：中国足协D级教练员继续教育报名工作，请咨询当地足协
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </tea-main>

</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import { getABList,personnel_admission_status} from '@/api/ab_signup/api'
import {statusKV,statusKVStudent} from '@/assets/js/status'
import {storageData} from "@/assets/js/storage";
import {mapMutations} from "vuex";
import { enroll_type } from "@/assets/js/status";

export default {
  name: "continue-list",
  components: {
    // "v-icon": () => import("vue-awesome/components/Icon"),
     "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
  },
  created() {
    this.getList()
  },
  data() {
    const member_type=storageData.getUserInfo().member_type
    return {
      statusKV,
      statusKVStudent,
      loading:true,
      vuescrollOpt: createScrollOpt(),
      dataList:[],
      showSelectOrganDialog:false,
      member_type,
      verifyResult:false,
      verifyMsg:{},
    }
  },
  methods: {
    getList() {
      this.loading=true;
      getABList({enroll_type:'continue_education'}).then(({data: {result, status}}) => {
        this.loading=false;
        if(status === 0) {
          this.dataList = result.list;
        }
      }).catch(err=>{
        this.loading=false;
      })
    },
    goBack(){
      this.$router.push('tran_his')
    },
    signUp(enroll) {
      // 如果存在登录标识进入培训班报名
        this.$router.push({
          path: `/${this.member_type}/register_info`,
          query: {uuid: enroll.enroll_uuid}
        })
    },
    viewResult(obj){
      if(!obj.showSelect) return
      this.getStatus(obj.enroll_uuid,obj.enroll_level)
      this.verifyResult = true;
    },
    getStatus(uuid,level) {
      personnel_admission_status({'enroll_uuid':uuid}).then(({data: {result, status}}) => {
        if(status === 0) {
          if ((level==='P' || level==='0' || level==='PRO') && result.enrollPersonnel.matriculate_status==='examThrough'){
            this.verifyMsg={"status":'已录取',"opinion":'enrollPersonnelAudit' in result? result.enrollPersonnelAudit.opinion:null}
          } else{
            this.verifyMsg={"status":statusKVStudent[result.enrollPersonnel.matriculate_status].text,"opinion":'enrollPersonnelAudit' in result? result.enrollPersonnelAudit.opinion:null}
          }

        }
      })
    }
  },
  filters:{
    enrollType(type){
      return enroll_type(type)
    },
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.enrollDetailNav
  padding-right 15px
  display: flex;
  align-items: center;
  justify-content space-between
  position relative
  font-size: $font_size_big;
.ab_signup_root
  display block
  width 100%
  height 100%
  .main-content-wrap
    display flex
    justify-content center
    user-select none
    color $color_white
    font-size $font_size_medium
    line-height inherit
    .cont_box
      display block
      background-color $block_bg_color_base
      box-shadow 2px 2px 2px rgba(0, 0, 0, 0.2)
      height 620px
      /*width 890px*/
      width 100%
      .header
        display flex
        justify-content center
        align-items center
        margin-bottom 20px
        .logo
          width 120px
          height 120px
          margin-right 15px
      .main
        display block

        position relative
        color $color_white
        .btn
          display inline-block
          line-height 1
          white-space nowrap
          cursor pointer
          text-align center
          outline none
          border-radius 5px
          padding 12px 20px
          background-color $color_suc
          // &.no_sign
          //   background-color transparent
            // border 1px solid
          &.btn_select
            padding 12px 8px
          &.no_begin
            background #FFF
            color #b2b2b2
          &.over
            background #b2b2b2
        .nav_btn
          // margin-top 15px
        .sign_list
          display block
          position relative
          overflow hidden
          height 580px
          .title_img
            display block
            padding 0 70px
            width 100%
            flex none
          .scroll_wrap
            display block
            width 100%
            height 100%
            .list_content
              display block
              padding 0 30px
              .item
                display flex
                align-items flex-end
                padding 34px 0 20px
                border-bottom 1px solid #ccc;
                &+.item
                  // margin-top 15px
                .item_left
                  display flex
                  flex-direction column
                  flex 1
                  .name
                    margin-bottom 10px
                    font-size 18px
                    line-height 18px;
                    &.gray{
                      color #b2b2b2
                    }
                  .tiem
                    .box
                      margin-right 10px
                      font-size 14px
                      line-height 14px
                      color #b2b2b2
                      &:last-child
                        margin-right 0

                .item_right
                  display flex
                  // flex-direction column
                  flex none
                  .selected-result
                    margin-bottom 5px
                  .btn
                    width 120px
                  .showRes{
                    margin-right :48px;
                  }
                  .seletImg
                    width 40px
                    height 40px
                    background url("../../assets/images/registration_signUp_sele.png")
                    background-size 100% 100%
                    margin-left 10px
                    cursor pointer
                    &.gray{
                      background url("../../assets/images/registration_signUp_gray.png")
                      background-size 100% 100%
                    }
                .name
                  display block
                  font-size $font_size_big
                  font-weight bolder
        .empty{
          height 580px
          width 100%
        }
        .attention
          padding 10px
          text-align center
          color #e64c4c

</style>
